import { Discount } from "shared/CourseDto"

export const getPriceAfter = (discount: Discount, price: number): number => {
    if(discount.isActive === false){
        return price;
    }
    return Math.floor(discount.factor * price);
}